import { getDefaultBarDesign, normalizeDesignTemplate } from "./barDesignTemplates";
import { normalizePlacementPages } from "./placementDefaults";

const DEFAULT_CONTENT = {
  goal: { amount: 50, currency: "USD" },
  messages: {
    initial: "Free shipping for orders over {order-value}!",
    progress: "You're only {order-value-progress} away from free shipping!",
    success: "Congratulations! You've got free shipping!",
  },
  translations: [],
};

const DEFAULT_UPSELL = {
  mode: "none",
  products: [],
  cta: { action: "add_to_cart", button_text: "Add to cart" },
};

const PRESET_LABELS = {
  product_inline_minimal: "Product page — minimal",
  cart_page_standard: "Cart page — standard",
  announcement_top_slim: "Announcement — top bar",
  home_page_banner: "Home page — banner",
};

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/** Defaults for the bar editor before the first save (matches server buildFromPreset). */
export function buildInitialBarFromPlacement(placementType, presetKey) {
  const design = deepClone(getDefaultBarDesign());
  const placement = {
    pages: "all_products",
    product_ids: [],
    selected_products: [],
    collection_ids: [],
    selected_collections: [],
    tags: [],
    excluded_pages: { page_types: [], specific_urls: [], url_keywords: [] },
    geolocation: { mode: "all_world", countries: [] },
    exclude: { mode: "none", product_ids: [], selected_products: [], tags: [] },
  };

  if (placementType === "cart_page") {
    placement.pages = "cart_page";
  } else if (placementType === "announcement_bar") {
    placement.pages = "every_page";
  }

  if (placementType === "home_page") {
    design.card = design.card || {};
    design.card.spacing = {
      ...(design.card.spacing || {}),
      outside_top: 0,
      outside_bottom: 0,
    };
    design.layout = { ...(design.layout || {}), widget_width_percent: 100 };
  }

  placement.pages = normalizePlacementPages(placement.pages, placementType);

  const key = presetKey || "product_inline_minimal";
  return {
    name: PRESET_LABELS[key] || "Free shipping bar",
    placementType: placementType || "product_page",
    presetKey: key,
    content: deepClone(DEFAULT_CONTENT),
    upsell: deepClone(DEFAULT_UPSELL),
    design: normalizeDesignTemplate(design),
    placement,
  };
}
